module.exports = __webpack_public_path__ + "img/customer-icon-11.5c21272c.png";